import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import env from '../../config/config';

import {
  jobsReportPath,
  overviewReportPath,
  systemsReportPath,
  tvDashboardPath,
} from 'contracts/constants';

import DesktopShellReportsNav from './DesktopShellReportsNav';
import MobileShellReportsNav from './MobileShellReportsNav';
import { ReportTypesNew } from 'models/ReportData';
import { UserSystemGroup, UserSystemGroupStrings } from 'store/storeTypes';

export type ShellReportsNavProps = {
  onNavClick?: () => {};
  userEmail?: string;
  tenantName?: string;
  importedTenantId?: string;
  isMobile?: boolean;
  activeReport?: ReportTypesNew;
  selectedSystemGroup: UserSystemGroupStrings;
  setIsOpen?: (isOpen: boolean) => void;
  setSystemGroup: (systemGroup: string) => void;
};
export type NavlinkType = {
  text: string;
  path: string;
  image: string;
};
const ShellReportsNav = memo((props: ShellReportsNavProps) => {
  const {
    isMobile,
    activeReport,
    importedTenantId,
    selectedSystemGroup,
    setIsOpen,
    setSystemGroup,
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const currentReport = history.location.pathname;

  //*allowed only for single client
  const xmrAllowedIds = env.XMR_CHART_FEATURE_ALLOWED_TENANT_IDS;
  const isTvDashboardAllowed =
    xmrAllowedIds?.includes(importedTenantId) && selectedSystemGroup === UserSystemGroup.Apollo;
  const navLinks: Array<NavlinkType> = [
    {
      text: t('reportsNav.overview'),
      path: overviewReportPath,
      image: 'menu-1-overview.svg',
    },
    {
      text: t('reportsNav.systemsAnalysis'),
      path: systemsReportPath,
      image: 'menu-2-sys-analysis.svg',
    },
    {
      text: t('reportsNav.jobsAnalysis'),
      path: jobsReportPath,
      image: 'menu-3-jobs-analysis.svg',
    },
  ];

  isTvDashboardAllowed &&
    navLinks.push({
      text: t('reportsNav.liveDashboard'),
      path: tvDashboardPath,
      image: 'menu-4-tv-dashboard.svg',
    });
  return isMobile ? (
    <MobileShellReportsNav
      activeReport={activeReport}
      currentReport={currentReport}
      navLinks={navLinks}
      setIsOpen={setIsOpen}
    />
  ) : (
    <DesktopShellReportsNav
      currentReport={currentReport}
      navLinks={navLinks}
      setSystemGroup={setSystemGroup}
    />
  );
});

export default ShellReportsNav;
